<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <wizard :step="3" :isDB="true"></wizard>
        <hr>
        <div class="panel-content" v-if="current">
            <div class="row columns">
                <div class="large-3 large-offset-3 columns">
                    <i class="fa fa-bed"  aria-hidden="true"></i>Autres sorties :
                </div>
                <div class="large-3 columns">
                    <i class="fa fa-money"  aria-hidden="true"></i> Gains :
                </div>
                <div class="large-3 columns">
                    <i class="fa fa-sign-language" aria-hidden="true"></i> Pop :
                </div>
            </div>
            <br>
            <div class="row columns" v-for="tr,idx in teamReportList">
                <div class="large-3 columns">
                    <div class="">{{tr.team.name}}</div>
                </div>
                <div class="large-3 columns">
                    <input type="number"
                        min="0"
                        step="1"
                        placeholder="esquives, rochers..."
                        v-model="other_casualties[idx]"
                        number>
                </div>
                <div class="large-3 columns">
                    <input type="number"
                        min="0"
                        step="10000"
                        placeholder="40000"
                        v-model="winnings[idx]"
                        number>
                </div>
                <div class="large-3 columns">
                    <select
                        placeholder="cliquez pour choisir"
                        name=""
                        id=""
                        v-model="fan_factor[idx]"
                        number>
                        <option value="-1">-1</option>
                        <option value="0">0</option>
                        <option value="1">+1</option>
                    </select>
                </div>
            </div>
            <br>
            <div class="row columns">
                <div v-if="error_msg" class="large-8 columns large-centered error-lbl">
                    {{error_msg}}
                </div>
                <br>
            </div>
            <div class="row columns">
                <div class="large-2 columns large-offset-4">
                    <button  @click="previous" class="full-width light-grey-button">précédent</button>
                </div>
                <div class="large-2 columns end">
                    <button  @click="validate" class="full-width">Suivant</button>
                </div>
            </div>
        </div>
        <div v-else>
            <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import Datepicker from 'vuejs-datepicker'
import teamReport from '../../api/team-report.api'

export default {
  name: 'mrDBStep4',
  components: {
    spinner,
    wizard,
    Datepicker
  },
  props: {
    'id': Number
  },
  watch: {
    trUpdated: function (newVal, oldVal) {
      if (this.mrUpdated === true) {
        this.mrUpdated = false
        this.trUpdated = false
      }
    },
    teamReportList: function (newMr, oldState) {
      if (oldState === null) {
        this.initDatas(newMr)
      }
    }
  },
  data () {
    return {
      'winnings': [],
      'other_casualties': [],
      'fan_factor': [],
      'error_msg': null,
      'isInit': false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'teamReportList'
    ]),
    ...mapGetters({
      current: 'detailedMatchReport'
    })
  },
  methods: {
    initDatas (trList) {
      let idx = 0
      trList.forEach(tr => {
        console.log(tr)
        this.winnings[idx] = tr.winnings * 1000
        this.fan_factor[idx] = tr.fan_factor
        this.other_casualties[idx] = tr.other_casualties
        tr.player_report.forEach(pr => {
          pr.player = pr.player.id
        })
        idx = idx + 1
      })
    },
    checkValid () {
      this.winnings.forEach(win => {
        if (win === '0') {
          this.error_msg = 'toutes les données n\'ont pas été saisies, veuillez vérifier'
          return false
        }
        if (parseInt(win, 10) < 10000) {
          this.error_msg = 'les gains doivent être au moins supérieurs à 10 000 pO, vérifiez le nombre de 0'
          return false
        }
      })
      this.fan_factor.forEach(ff => {
        if (ff === undefined) {
          this.error_msg = 'toutes les données n\'ont pas été saisies, veuillez vérifier'
          return false
        }
      })
      this.other_casualties.forEach(ot => {
        if (ot === null) {
          this.error_msg = 'toutes les données n\'ont pas été saisies, veuillez vérifier'
          return false
        }
      })
      return true
    },
    previous () {
      let idx = this.teamReportList.length
      this.$router.push({
        name: 'mrStep3',
        params: {
          id: this.teamReportList[idx - 1].id,
          teamid: this.teamReportList[idx - 1].team.id,
          matchId: this.current.id
        }
      })
    },
    goToNext () {
      this.$router.push({name: 'mrDBStep5', params: { id: this.id }})
    },
    validate () {
      if (this.checkValid() === false) {
        return
      }
      // bulk update team report datas
      let trArray = []
      let idx = 0
      this.teamReportList.forEach(tr => {
        let newtr = {}
        newtr.id = tr.id
        newtr.winnings = this.winnings[idx] / 1000
        newtr.other_casualties = this.other_casualties[idx]
        newtr.fan_factor = this.fan_factor[idx]
        idx++
        trArray.push(newtr)
      })

      teamReport.api.bulkUpdateTeamReport(trArray).then(
        response => {
          this.trUpdated = true
          this.goToNext()
        },
        error => {
          this.errorsList.push(error.body.detail)
        }
      )
    }
  },
  mounted () {
    this.$store.dispatch('invalidateDetailedMatchReport')
    this.$store.dispatch('getDetailedMatchReport', this.id)
    this.$store.dispatch('getTeamReportListForMatch', this.id)
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.note {
font-size:0.5rem;
}
</style>



// WEBPACK FOOTER //
// mr-db-step-4.vue?4adaeb72